'use strict';
var isObject = require('../internals/is-object');
var getInternalState = require('../internals/internal-state').get;

module.exports = function isRawJSON(O) {
  if (!isObject(O)) return false;
  var state = getInternalState(O);
  return !!state && state.type === 'RawJSON';
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/is-raw-json.js
// module id = 502
// module chunks = 29